import { useEffect, useState, useCallback } from 'react';
import {
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import dayjs from 'dayjs';
import RCSettlementDashboard from '../../components/settlement/dashboard/RCSettlementDashboard';
import { PAGE_CARD_SX } from '../../theme/pageCardSx';

const STORAGE_KEY = 'avatye.ops.dashboard.monthEndSettlement.filterOptions';

type DateFilter = {
  year: number;
  month: number;
};

export default function MonthEndSettlement() {
  const getStoredFilterOptions = (): DateFilter => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return {
          year: parsed.year ?? dayjs().year(),
          month: parsed.month ?? dayjs().subtract(1, 'month').month() + 1,
        };
      }
    } catch {
      // ignore
    }
    return {
      year: dayjs().year(),
      month: dayjs().subtract(1, 'month').month() + 1,
    };
  };

  const initialFilterOptions = getStoredFilterOptions();

  const [year, setYear] = useState<number>(initialFilterOptions.year);
  const [month, setMonth] = useState<number>(initialFilterOptions.month);

  const saveFilterOptions = useCallback((filterOptions: DateFilter) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filterOptions));
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    saveFilterOptions({ year, month });
  }, [year, month, saveFilterOptions]);

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Box
        sx={{
          ...PAGE_CARD_SX,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mt: 0,
          mb: 2,
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          월말 정산 기간 선택
        </Typography>

        <FormControl size="small">
          <Select value={year} onChange={(e) => setYear(Number(e.target.value))}>
            {Array.from({ length: 10 }, (_, i) => {
              const currentYear = dayjs().year();
              const yearOption = currentYear - 2 + i;
              return (
                <MenuItem key={yearOption} value={yearOption}>
                  {yearOption}년
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <FormControl size="small">
          <Select value={month} onChange={(e) => setMonth(Number(e.target.value))}>
            {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
              <MenuItem key={m} value={m}>
                {m.toString().padStart(2, '0')}월
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <RCSettlementDashboard year={year} month={month} />
    </Box>
  );
}
